import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import store from "./store";
import Vant from "vant";
import VueCookie from "vue-cookie";
import "vant/lib/index.css";
import * as cs from "./assets/js/gb";
import * as req from "@/api/common";
import * as req2 from "@/api/newcommon";
import eruda from "eruda"

import Bus from "@/utils/bus";
import "vant/lib/index.less";
import "@/utils/rem.js";

import "@/styles/color.less"; // 引入换肤css
// 将moment.js引入并放置在vue原型链上
import moment from "moment";

// 引入并遍历设置全局filter
import * as filters from "@/utils/lib/filter";

//vue-introjs
import intro from 'intro.js' // 引入introjs库
import 'intro.js/introjs.css' // 引入introjscss样式
import 'intro.js/themes/introjs-modern.css' // 引入introjs主题
Vue.prototype.$intro = intro

Vue.config.productionTip = false;

Vue.use(Vant);

Vue.use(VueCookie);

// 挂载全局
Vue.prototype.bus = Bus; // 通信中间组件
Vue.prototype.moment = moment;

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});


router.beforeEach((to, from, next) => {
  if (
    to.path === "/onlineMall" &&
    !store.state.user.permissionArray.includes("900001")
  ) {
    router.push({ path: "/index" });
  } else if (to.path === "/onlineMall" && store.state.user.accounttype == 80) {
    next();
  } else if (to.path === "/virtualloagin") {
    next();
  } else {
    next();
  }
  if (to.meta.title) {
    document.title = to.meta.title
    setTimeout(() => {
      let iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.onload = () => {
        setTimeout(() => {
          document.body.removeChild(iframe)
        }, 0)
      }
      document.body.appendChild(iframe)
    }, 0)

  }
  next();
});

axios
  .get("./config.json")
  .then((result) => {
    Vue.prototype.$baseConfig = result.data;
    Vue.prototype.$http = { ...req, ...req2 };
    if (!Vue.prototype.$baseConfig.enableConsole) {
      cs.clog();
    }
    if (Vue.prototype.$baseConfig.mc) {
      //eslint-disable-next-line no-undef
      eruda.init()
    }
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch((error) => {
    console.log("get baseConfig error..." + error);
  });
